module.exports = __webpack_public_path__ + "img/brand13.25607353.png";